import React, { useState } from 'react'
import { BackArrowButton, Button, DatePickerInput } from '@doseme/cohesive-ui'
import saveAs from 'file-saver'
import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { REPORTS_URL } from '../../../../constants/urls/frontend'
import { TProps } from './types'
import { REPORTS_SE_CSV_URL } from '../../../../constants/urls/backend'
import { apiRoute } from '../../../../utils/routeUtils'
import { axiosWithAdal } from '../../../../utils/http'

import './index.scss'

const SubscriptionExpiry: React.FC<TProps> = ({ history }): JSX.Element => {
  const newDate = new Date()
  const [startDate, setStartDate] = useState<Date>(
    new Date(newDate.getFullYear(), newDate.getMonth(), 1, 0, 0, 0)
  )
  const [endDate, setEndDate] = useState<Date>(
    new Date(newDate.getFullYear(), newDate.getMonth() + 2, 1, 0, 0, -1)
  )
  const [downloading, setDownloading] = useState(false)
  const handleBackArrowButton = () => {
    history.push(REPORTS_URL)
  }

  const submitRequest = async () => {
    // Get the ISO string representation of the date
    const startISOString = startDate.toISOString()
    const endISOString = endDate.toISOString()

    if (startDate && endDate) {
      setDownloading(true)
      const config: AxiosRequestConfig = {
        headers: {
          Accept: 'text/csv'
        }
      }
      await axiosWithAdal
        .get(apiRoute(REPORTS_SE_CSV_URL(startISOString, endISOString)), config)
        .then((response: AxiosResponse) => {
          const reportFileResponse = response.data as string
          const reportFileBlob = new Blob([reportFileResponse], { type: 'application/csv' })
          saveAs(
            reportFileBlob,
            response.headers['content-disposition']?.match(/"([^"]+)"/)?.[1] ||
              `subscriptions_expiring_between_${startISOString}_and_${endISOString}.csv`
          )
        })
        .catch((error) => {
          alert('unable to retrieve requested data: ' + JSON.stringify(error))
        })
      setDownloading(false)
    }
  }

  return (
    <div className='dma-wrapper'>
      <div className='dma-back-button'>
        <BackArrowButton onClick={handleBackArrowButton} />
      </div>
      <div>
        <div className='dma-title'>Create report: subscription expiry</div>
        <div className='create-report-container'>
          <div className='dma-subtitle'>
            Generate a list of hospitals with subscriptions set to expire during the defined date range
          </div>
          <div className='d-flex mb-5'>
            <div>
              <DatePickerInput
                label='Start date:'
                fieldState='valid'
                hasValidation={false}
                value={startDate}
                onChange={(value) => setStartDate(value)}
                testId='date-input'
                maxDate={endDate}
              />
            </div>
            <div className='ml-4'>
              <DatePickerInput
                label='End date:'
                fieldState='valid'
                hasValidation={false}
                value={endDate}
                onChange={(value) => setEndDate(value)}
                testId='date-input'
                minDate={startDate}
              />
            </div>
          </div>
          <div className='dma-seperater-line'></div>
          <div className='dma-download-btn'>
            <Button onClick={submitRequest} loading={downloading} variant='primary'>
              Download
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export { SubscriptionExpiry }
